import { ReactNode } from "react";
import { cx } from "shared/utils";

type RowProps = {
  title: ReactNode;
  value?: string | ReactNode;
  className?: string;
  valueClassName?: string;
  keyClassName?: string;
  fullWidthRow?: boolean;
};

export const Row = ({
  title,
  value,
  className,
  valueClassName,
  keyClassName,
  fullWidthRow
}: RowProps) => {
  return (
    <div
      className={cx(
        "flex gap-2 text-sm font-medium",
        fullWidthRow ? "justify-between" : "",
        className
      )}
    >
      <p
        className={cx(
          " text-content-300 print:text-content-800",
          fullWidthRow ? "" : "w-[200px]",
          keyClassName
        )}
      >
        {title}
      </p>
      <p
        className={cx(
          "break-words text-content-1000",
          fullWidthRow ? "" : "w-[180px]",
          valueClassName
        )}
      >
        {value != null && value !== "" ? value : "-"}
      </p>
    </div>
  );
};
